import React, { useCallback, useEffect, useState } from "react";
import { HeadingTitle } from "../ModalContainer";
import axios from "axios";
import { toast } from "react-toastify";
import secureLocalStorage from "react-secure-storage";
import { BASEURI } from "../../../Middleware/axiosInstance";
import Dropdown from "../../Dropdown/Dropdown";

const MasterCutterList = (props) => {
  const token = JSON.parse(secureLocalStorage.getItem("user_UUID_MFG"))?.token;

  const { close, handleCutterSelect, orderId, IsPicked } = props;

  const [cutterMasterList, setCutterMasterList] = useState([]);
  const [cutterMasterDropdown, setCutterMasterDropdown] = useState([]);
  const [selectedId, setSelectedId] = useState(null);

  const handleCheckboxChange = (id) => {
    setSelectedId(id); // keep it as string (recommended if id from API is string)
    handleCutterSelect(orderId, IsPicked, id);
  };

  const fetchUserList = useCallback(async () => {
    try {
      const { data } = await axios.post(`${BASEURI}`, {
        service_name: "manufacture_order_get_picker_list",
        token: token,
      });

      if (data.status === 1) {
        toast.success(data.msg || "Success");

        const cutter__masters__list = Object.entries(data?.cutter_masters).map(
          ([id, name]) => ({
            id: id, // keep id as string
            name: name,
          })
        );

        const cutter__MasterDropdown = Object.entries(data?.cutter_masters).map(
          ([id, name]) => ({
            id: id, // keep id as string
            label: name,
            value: name,
          })
        );

        setCutterMasterDropdown(cutter__MasterDropdown);
        setCutterMasterList(cutter__masters__list);
      } else {
        toast.error(data.msg);
      }
    } catch (err) {}
  }, [token]);

  useEffect(() => {
    fetchUserList();
  }, [token, fetchUserList]);

  // console.log("CUTTER MASTER LIST: ", cutterMasterList);

  const handleFilterCutterMaster = (val) => {
    // console.log("VAL: ", val);

    if (val === null) {
      fetchUserList();
      return;
    }

    let filter = cutterMasterList.filter(
      (item) => parseInt(item.id) === parseInt(val?.id)
    );

    // console.log("FILTER VALUE: ", filter);

    setCutterMasterList(filter);
  };

  return (
    <>
      <HeadingTitle
        colorRed={false}
        title={`Cutter Master List`}
        closeModal={close}
      />
      <div>
        <div className="search__box__filter">
          <Dropdown
            dropdown={cutterMasterDropdown}
            placeholder="Search Master Cutter"
            onData={handleFilterCutterMaster}
          />
        </div>
        <div className="cutter__master__list__row">
          {cutterMasterList.map((i) => (
            <div key={i.id}>
              <div className="form-group">
                <input
                  type="checkbox"
                  id={`checkbox-${i.id}`}
                  checked={selectedId === i.id} // Compare as string
                  onChange={() => handleCheckboxChange(i.id)} // Keep id as string
                />

                <label htmlFor={`checkbox-${i.id}`}>
                  &nbsp;&nbsp; {i.id} - {i.name}
                </label>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
};

export default MasterCutterList;
